import React from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { NotificationsNone } from '@mui/icons-material'
import { BannerCloseTypes, BannerKey } from 'src/Libs/banners/types'
import { makeStyles } from 'tss-react/mui'
import { Banner } from 'src/Components/banner'
import { isFlowTheme } from 'src/Libs/utils'

const SUPPORT_EMAIL = isFlowTheme ? 'mailto:beratung.em@hager.com' : undefined
interface StyleProps {
  downMd: boolean
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  containerStyle: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,

    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      gap: theme.spacing(2),
    },
  },
}))

/**
 * Component to display an alert-banner if only read-access is granted.
 */
const ReadOnlyBanner: React.FC = () => {
  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))
  const { classes } = useStyles({ downMd })
  const keyToUse = isFlowTheme ? 'systemSettings.alert.flow-read-only' : 'systemSettings.alert.read-only'

  return (
    <Banner
      i18nKey={keyToUse}
      linkHref={SUPPORT_EMAIL}
      icon={<NotificationsNone sx={{ color: 'warning.main', height: 30, width: 30 }} />}
      bannerKey={BannerKey.ReadOnlyBanner}
      closeType={BannerCloseTypes.permanentOrTemporary}
      containerStyle={classes.containerStyle}
    />
  )
}

export default ReadOnlyBanner
